/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetIntegrationsConfig200ResponseTehtrisTriggersCriticalities
 */
export interface GetIntegrationsConfig200ResponseTehtrisTriggersCriticalities {
    /**
     * 
     */
    critical?: boolean;
    /**
     * 
     */
    high?: boolean;
    /**
     * 
     */
    medium?: boolean;
    /**
     * 
     */
    low?: boolean;
    /**
     * 
     */
    info?: boolean;
}

/**
 * Check if a given object implements the GetIntegrationsConfig200ResponseTehtrisTriggersCriticalities interface.
 */
export function instanceOfGetIntegrationsConfig200ResponseTehtrisTriggersCriticalities(value: object): value is GetIntegrationsConfig200ResponseTehtrisTriggersCriticalities {
    return true;
}

export function GetIntegrationsConfig200ResponseTehtrisTriggersCriticalitiesFromJSON(json: any): GetIntegrationsConfig200ResponseTehtrisTriggersCriticalities {
    return GetIntegrationsConfig200ResponseTehtrisTriggersCriticalitiesFromJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseTehtrisTriggersCriticalitiesFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetIntegrationsConfig200ResponseTehtrisTriggersCriticalities {
    if (json == null) {
        return json;
    }
    return {
        
        'critical': json['critical'] == null ? undefined : json['critical'],
        'high': json['high'] == null ? undefined : json['high'],
        'medium': json['medium'] == null ? undefined : json['medium'],
        'low': json['low'] == null ? undefined : json['low'],
        'info': json['info'] == null ? undefined : json['info'],
    };
}

export function GetIntegrationsConfig200ResponseTehtrisTriggersCriticalitiesToJSON(json: any): GetIntegrationsConfig200ResponseTehtrisTriggersCriticalities {
    return GetIntegrationsConfig200ResponseTehtrisTriggersCriticalitiesToJSONTyped(json, false);
}

export function GetIntegrationsConfig200ResponseTehtrisTriggersCriticalitiesToJSONTyped(value?: GetIntegrationsConfig200ResponseTehtrisTriggersCriticalities | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'critical': value['critical'],
        'high': value['high'],
        'medium': value['medium'],
        'low': value['low'],
        'info': value['info'],
    };
}

